import { useSelector } from 'react-redux';
import cn from 'classnames';

import { Grid } from '@wf/sw-ui-kit';

import Separator from '../../../../components/Separator';
import AdditionalField from './AdditionalField';

import { type Tab } from '../../types/enums';

import { licenseTypeAdditionalFieldsByTabsSelector } from '../../store/selectors';

import styles from './AdditionalFields.module.scss';

interface IAdditionalFieldsProps {
  tab: Tab;
  maxColumns?: number;
  fieldNamePrefix?: string;
  configNamePrefix?: string;
  viewMode?: boolean;
}

function AdditionalFields({
  tab,
  fieldNamePrefix,
  configNamePrefix,
  maxColumns = 3,
  viewMode,
}: IAdditionalFieldsProps) {
  const additionalFields = useSelector(licenseTypeAdditionalFieldsByTabsSelector);
  const currentTabAdditionalFields = additionalFields[tab];

  if (!currentTabAdditionalFields || currentTabAdditionalFields?.length === 0) {
    return null;
  }

  return currentTabAdditionalFields?.length ? (
    <Grid>
      <Separator className={cn('grid-full-width', styles.separator)} />
      {currentTabAdditionalFields?.map((row, index) => {
        const columns = row.filter(Boolean);

        return (
          <Grid key={index} columns={`repeat(${maxColumns}, minmax(0, 1fr))`}>
            {columns.map((column) => (
              <AdditionalField
                configNamePrefix={configNamePrefix}
                fieldNamePrefix={fieldNamePrefix}
                key={column.positionInRow}
                viewMode={viewMode}
                config={column}
              />
            ))}
          </Grid>
        );
      })}
    </Grid>
  ) : null;
}

export default AdditionalFields;
